import { render, staticRenderFns } from "./GroupPlaceholder.vue?vue&type=template&id=4e6fa2a5&scoped=true&"
import script from "./GroupPlaceholder.vue?vue&type=script&lang=js&"
export * from "./GroupPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fa2a5",
  null
  
)

export default component.exports